var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{ref:"ImageWithResolution",attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.setWidthHeight}}),_vm._v(" "),(_vm.width && _vm.height)?_c('small',{staticClass:"d-block text-center"},[_vm._v(_vm._s(_vm.width)+"x"+_vm._s(_vm.height)+" ("+_vm._s(_vm.alt)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }